import { render, staticRenderFns } from "./LenonButton.vue?vue&type=template&id=2f132db7&scoped=true&"
import script from "./LenonButton.vue?vue&type=script&lang=js&"
export * from "./LenonButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f132db7",
  null
  
)

export default component.exports